import { Injectable } from "@angular/core";

@Injectable()
export class LoaderService {
    isLoaderVisible: boolean = true;
}
